import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const SearchTestView = () => {
  return (
    <Box>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Search Test
        </Typography>
        <Typography variant="body1">
          Search testing interface coming soon...
        </Typography>
      </Container>
    </Box>
  );
};

export default SearchTestView;
